import { Currency } from 'constants/misc'

export function isValidCurrency(currency?: Currency | string | null): currency is Currency {
  if (!currency) return false
  return !!Currency[currency as Currency]
}